import { PENDENCY_CATEGORIES, pendencyStatusLabel } from '../../telas/inbox-time/tela4-adapter';

/** Item 485 — estados em que a pendência já acabou (ADR-109). */
const TERMINAL_PENDENCY_STATUSES: ReadonlySet<string> = new Set([
  'resolved',
  'cancelled',
  'expired',
  'archived',
]);

import type { PendencyCardVM } from '../../view-models';
import type React from 'react';

export function PendencyTeamCard({
  p,
  selected,
  onToggleSelect,
  onReassign,
  onPostpone,
  onResolve,
  onOpenConversation,
}: {
  p: PendencyCardVM;
  selected?: boolean;
  onToggleSelect?: (id: string) => void;
  onReassign?: (id: string) => void;
  onPostpone?: (id: string) => void;
  onResolve?: (card: PendencyCardVM) => void;
  /** Abre a conversa da pendência (gate core-conversation na page); ausente = sem affordance. */
  onOpenConversation?: (conversationId: string) => void;
}): React.JSX.Element {
  const cat = p.cat !== null ? PENDENCY_CATEGORIES[p.cat] : undefined;
  // Item 485 — pendência em estado terminal não se reatribui, adia nem resolve, e «vence em»
  // não faz sentido para o que já acabou. Fonte dos estados: PENDENCY_STATUS_LABELS (ADR-109).
  const terminal = TERMINAL_PENDENCY_STATUSES.has(p.status);
  const overdueClass = p.overdue
    ? ' pend-team-card--overdue'
    : p.urgent
      ? ' pend-team-card--urgent'
      : '';
  const dueLabel = terminal
    ? ''
    : p.overdue
      ? `vencida há ${p.overdueLabel ?? ''}`
      : p.dueHours !== null
        ? `vence em ${p.dueHours}h`
        : p.dueDays !== null
          ? `vence em ${p.dueDays}d`
          : '';
  return (
    <div className={'pend-team-card' + overdueClass}>
      <div className="pend-team-card__head">
        {onToggleSelect !== undefined && (
          <input
            type="checkbox"
            className="pend-team-card__check"
            checked={selected === true}
            onChange={() => {
              onToggleSelect(p.id);
            }}
            aria-label={`Selecionar pendência ${p.id}`}
          />
        )}
        <span className={`status-pill status-pill--${p.status}`}>
          {pendencyStatusLabel(p.status)}
        </span>
        {cat !== undefined && p.cat !== null && (
          <span className={`cat-pill cat-pill--${cat.tone}`}>
            {cat.icon} {cat.label}
          </span>
        )}
        <span style={{ flex: 1 }} />
      </div>
      <div className="pend-team-card__title">{p.title}</div>
      <div className="pend-team-card__meta">
        {p.conv !== null && onOpenConversation !== undefined && (
          <>
            <button
              type="button"
              className="btn-ghost-mini"
              onClick={() => onOpenConversation(p.conv!)}
            >
              Abrir conversa
            </button>
            <span className="pend-team-card__sep" aria-hidden="true" />
          </>
        )}
        <span>
          Cliente: <b>{p.customer}</b>
        </span>
        <span className="pend-team-card__sep" aria-hidden="true" />
        <span style={{ color: p.overdue ? 'var(--danger-fg)' : 'var(--fg-3)' }}>{dueLabel}</span>
        {p.postponeCount > 0 && (
          <span className="tweaks-hint" style={{ marginLeft: 'auto' }}>
            adiada {p.postponeCount}×
          </span>
        )}
      </div>
      {!terminal &&
        (onReassign !== undefined || onPostpone !== undefined || onResolve !== undefined) && (
          <div className="pend-team-card__actions">
            {onReassign !== undefined && (
              <button type="button" className="btn-ghost-mini" onClick={() => onReassign(p.id)}>
                Reatribuir
              </button>
            )}
            {onPostpone !== undefined && (
              <button type="button" className="btn-ghost-mini" onClick={() => onPostpone(p.id)}>
                Adiar
              </button>
            )}
            {onResolve !== undefined && (
              <button type="button" className="btn-ghost-mini" onClick={() => onResolve(p)}>
                Resolver
              </button>
            )}
          </div>
        )}
    </div>
  );
}
